import { EmptyListPlaceholder } from '@frontend/components/elements/EmptyListPlaceholder';
import { translateKey } from '../../../translate';

export function EmptyContactsAndTasks(props: { message: 'openTasks' | 'closedTasks' | 'contacts' }) {
    let type;

    switch (props.message) {
        case 'openTasks':
            type = 'noOpenTasksForThisPatient';
            break;
        case 'closedTasks':
            type = 'noClosedTasksForThisPatient';
            break;
        case 'contacts':
            type = 'noContactsForThisPatient';
            break;
        default:
            break;
    }

    return <EmptyListPlaceholder subtitle={translateKey(`contactsAndTasks.${type}`)}></EmptyListPlaceholder>;
}
